import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../../Utils/base_url';
import { blockInvalidChar } from "../../components/blockInvalidChar";
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AjouteMenu, AfficheMenu, AfficheMenuRestaurant } from '../../Api/RestaurantApi/MenuApi';
import { v4 as uuidv4 } from 'uuid';
import { PhotoProvider, PhotoView } from 'react-photo-view';


// Visualiser
import Pagination from '@material-ui/lab/Pagination';
import Slider from "react-slick";
import Image6 from "../../Image/une (1).png";
import Image7 from "../../Image/une (2).jpg";
import Image10 from "../../Image/une (5).png";
import Image11 from "../../Image/une (6).jpg";
import Chef from "../../Image/chef.png";
import EntrerIcon from "../../Image/entrer.png";
import PlatIcon from "../../Image/plats.png";
import DessertIcon from "../../Image/desserts.png";
import BoissonIcon from "../../Image/boisson.png";
import Money from "../../Image/money.png";
import Plus from "../../Image/plus.png";
import MenusAvatar from "../../Image/menus.png";
import Avatar1 from "../../Image/avatar1.png";
import Avatar2 from "../../Image/Avatar2.png";



import './css/menuResto.css';

const Menus = () => {
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [activeMenu, setActiveMenu] = useState(true);
    const [libelleMenu, setLibelleMenu] = useState('');
    const [prixMenu, setPrixMenu] = useState('');
    const [statusContenuMenu, setStatusContenuMenu] = useState(true);
    const [errorContenuMenu, setErrorContenuMenu] = useState('');
    const [platMenu, setPlatMenu] = useState('');
    const [statusDisponible, setStatusDisponible] = useState(true);
    const [errorDisponible, setErrorDisponible] = useState('');
    const [statuReservant, setStatuReservant] = useState(false);
    const [statusIntroduire, setStatusIntroduire] = useState(false);
    const [errorIntroduire, setErrorIntroduire] = useState('');
    const [introduire, setIntroduire] = useState('');

    const [entrer, setEntrer] = useState('');

    const [dataEntrer, setDataEntrer] = useState([]);
    const [plat, setPlat] = useState('');
    const [dataPlat, setDataPlat] = useState([]);
    const [dessert, setDessert] = useState('');
    const [dataDessert, setDataDessert] = useState([]);
    const [nomAutre, setNomAutre] = useState('');
    const [autre, setAutre] = useState('');
    const [dataAutre, setDataAutre] = useState([]);

    const [statusEntrer, setStatusEntrer] = useState(false);
    const [errorEntrer, setErrorEntrer] = useState('');
    const [statusPlat, setStatusPlat] = useState(false);
    const [errorPlat, setErrorPlat] = useState('');
    const [statusDessert, setStatusDessert] = useState(false);
    const [errorDessert, setErrorDessert] = useState('');
    const [statusAutre, setStatusAutre] = useState(false);
    const [errorAutre, setErrorAutre] = useState('');
    const [errorLibelleMenu, setErrorLibelleMenu] = useState('');
    const [errorPrixMenu, setErrorPrixMenu] = useState('');

    const [data, setData] = useState([]);
    const [activeForm, setActiveForm] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [fullscreen, setFullscreen] = useState(true);
    const [ajouterMenu, setAjouteMenu] = useState(false);


    const [toutAvecContenu, setToutAvecContenu] = useState([]);
    const [toutMoment, setToutMoment] = useState([]);
    const [toutDisponible, setToutDisponible] = useState([]);
    const [toutEntrer, setToutEntrer] = useState([]);
    const [updateEntrer, setUpdateEntrer] = useState();
    const [toutPlat, setToutPlat] = useState([]);
    const [updatePlat, setUpdatePlat] = useState();
    const [toutDessert, setToutDessert] = useState([]);
    const [updateDessert, setUpdateDessert] = useState();
    const [toutAutre, setToutAutre] = useState([]);
    const [updateAutre, setUpdateAutre] = useState([]);

    const [autrePlatMenu, setAutrePlatMenu] = useState({
        check: false,
        name: ""
    })
    const [avecContenu, setAvecContenu] = useState([{
        id: 1,
        check: false,
        name: "Boisson",
    },
    {
        id: 2,
        check: false,
        name: "Café",
    },
    ]);


    const [moment, setMoment] = useState([{
        id: 1,
        check: false,
        name: "Petit-déjeuner",
    },
    {
        id: 2,
        check: false,
        name: "Déjeuner",
    },
    {
        id: 3,
        check: false,
        name: "Diner",
    }]);

    const [disponible, setDisponible] = useState([{
        id: 1,
        check: false,
        name: "Lundi"
    },
    {
        id: 2,
        check: false,
        name: "Mardi"
    },
    {
        id: 3,
        name: "Mercredi",
        check: false
    },
    {
        id: 4,
        name: "Jeudi",
        check: false
    },
    {
        id: 5,
        name: "Vendredi",
        check: false
    },
    {
        id: 7,
        name: "Samedi",
        check: false
    },
    {
        id: 8,
        name: "Dimanche",
        check: false
    }]);








    // Visualiser

    const [show, setShow] = useState(false);
    const [showSpecial, setShowSpecial] = useState(false);

    const [description, setDescription] = useState("");
    const [planUrl, setPlanUrl] = useState("");
    const [precision, setPrecision] = useState("");
    const [selectImage, setSelectImage] = useState([]);
    const [cuisine, setCuisine] = useState([]);
    const [promoSpecial, setPromoSpecial] = useState([]);
    const [promotion, setPromotion] = useState([]);
    const [prixMoyen, setPrixMoyenne] = useState([]);
    const [entrerResto, setEntrerResto] = useState([]);
    const [platResto, setPlatResto] = useState([]);
    const [dessertResto, setDessertResto] = useState([]);
    const [boisson, setBoisson] = useState([]);


    const [service, setService] = useState([]);
    const [regime, setRegime] = useState([]);
    const [payement, setPayement] = useState([]);


    const [elementMenu, setElementMenu] = useState([]);
    const [elementAvecContenu, setElementAvecContenu] = useState([]);
    const [elementMoment, setElementMoment] = useState([]);
    const [elementDisponible, setElementDisponible] = useState([]);
    const [elementEntrer, setElementEntrer] = useState([]);
    const [elementPlat, setElementPlat] = useState([]);
    const [elementDessert, setElementDessert] = useState([]);
    const [elementAutre, setElementAutre] = useState([]);




    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        pauseOnHover: true,
        speed: 2000,
        autoplaySpeed: 8000,
        swipeToSlide: true,
        slidesToShow: selectImage.length < 4 ? selectImage.length : 4,
        slidesToScroll: selectImage.length < 4 ? selectImage.length : 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: selectImage.length < 3 ? selectImage.length : 3,
                    slidesToScroll: selectImage.length < 3 ? selectImage.length : 3,
                    initialSlide: selectImage.length < 3 ? selectImage.length : 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: selectImage.length < 2 ? selectImage.length : 2,
                    slidesToScroll: selectImage.length < 2 ? selectImage.length : 2,
                    initialSlide: selectImage.length < 2 ? selectImage.length : 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
                    slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
                    slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
                }
            }
        ]
    };



    const handleCloseDetailMenu = () => setShow(false);
    const handleShowDetailMenu = (el) => {

        const existeAvecContenu = toutAvecContenu.filter((item) => item.idMenu === el.id);
        const existeMoment = toutMoment.filter((item) => item.idMenu === el.id);
        const existeDisponible = toutDisponible.filter((item) => item.idMenu === el.id);
        const existeEntrer = toutEntrer.filter((item) => item.idMenu === el.id);
        const existePlat = toutPlat.filter((item) => item.idMenu === el.id);
        const existeDessert = toutDessert.filter((item) => item.idMenu === el.id);
        const existeAutre = toutAutre.filter((item) => item.idMenu === el.id);



        setElementMenu(el);
        setElementAvecContenu(existeAvecContenu);
        setElementMoment(existeMoment);
        setElementDisponible(existeDisponible);
        setElementEntrer(existeEntrer);
        setElementPlat(existePlat);
        setElementDessert(existeDessert);
        setElementAutre(existeAutre);
        setShow(true);

    };

    const handleCloseDetailSpecial = () => setShowSpecial(false);
    const handleShowDetailSPecial = () => {
        setShowSpecial(true);

    };


    const viewPromotion = () => {
        const existePromo50 = promotion.find((el) => el.libelle === "Promotion de -50%");
        const existePromo40 = promotion.find((el) => el.libelle === "Promotion de -40%");
        const existePromo30 = promotion.find((el) => el.libelle === "Promotion de -30%");
        const existePromo20 = promotion.find((el) => el.libelle === "Promotion de -20%");
        const existePromo10 = promotion.find((el) => el.libelle === "Promotion de -10%");
        const existePromoSpecial = promotion.find((el) => el.libelle === "Promotion : Menu spécial");

        if (existePromo50) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -50%</span>);
        } else if (existePromo40) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -40%</span>);
        } else if (existePromo30) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -30%</span>);
        } else if (existePromo20) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -20%</span>);
        } else if (existePromo10) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -10%</span>);
        } else if (existePromoSpecial) {
            return (<span><i className='fa fa-bullhorn'></i>Menu spécial</span>);

        } else {
            return (<span><i className='fa fa-bullhorn'></i>Pas de promotion ...</span>);
        }


    }



    const viewCreneau = (creneau) => {
        var opt_month = { month: 'long' };
        function toTitleCase(str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        }
        var MonthDu = toTitleCase(new Date(creneau?.du).toLocaleDateString("fr-FR", opt_month));
        var MonthAu = toTitleCase(new Date(creneau?.au).toLocaleDateString("fr-FR", opt_month));
        const du = new Date(creneau?.du);
        const au = new Date(creneau?.au);
        const fin = new Date(creneau?.au).getTime();
        const date = new Date();
        if (fin >= date.getTime()) {
            return (<p>{du.getDate() + " " + MonthDu + " " + du.getFullYear()} au {au.getDate() + " " + MonthAu + " " + au.getFullYear()}</p>);
        } else {
            return (<p>Promotion Expirée !</p>)
        }
    }



    // Fin visualiser


    let location = useLocation();

    const restaurant = useSelector((state) => state.restaurant);




    useEffect(() => {
        Menu();
        menuRestaurant();
    }, []);

    const Menu = () => {
        setLoadData(true);
        AfficheMenu(restaurant.id).then(function (response) {
            console.log(response.data.donner);
            response.data.donner.forEach((el, index) => {
                el.avecContenus.map((avecMenu) => {
                    return setToutAvecContenu((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: avecMenu.libelle, check: true }]);
                });
                el.moments.map((moment) => {
                    return setToutMoment((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: moment.libelle, check: true }]);
                });
                el.jours.map((jour) => {
                    return setToutDisponible((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: jour.libelle, check: true }]);
                });
                el.entrerMenus.map((entrerMenu) => {
                    return setToutEntrer((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: entrerMenu.libelle }]);
                });
                el.platMenus.map((platMenu) => {
                    return setToutPlat((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: platMenu.libelle }]);
                });
                el.dessertMenus.map((dessertMenu) => {
                    return setToutDessert((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: dessertMenu.libelle }]);
                });
                el.autreMenus.map((autreMenu) => {
                    return setToutAutre((prev) => [...prev, { idMenu: index + 1, id: uuidv4(), name: autreMenu.libelle }]);
                });

                setData((prev) => [...prev,
                {
                    id: index + 1,
                    activeMenu: el.activeMenu === "1" ? true : false,
                    libelleMenu: el.nomMenu,
                    prixMenu: el.prixMenu,
                    statusContenuMenu: el.statusContenu === "1" ? true : false,
                    platMenu: el.platMenu,
                    autrePlatMenu: el.autrePlatMenu,
                    statusAutrePlatMenu: el.autrePlatMenu !== "" ? true : false,
                    statusDisponible: el.statusDisponible === "1" ? true : false,
                    statusReservant: el.statusReservant === "1" ? true : false,
                    statusIntroduire: el.statusIntroduire === "1" ? true : false,
                    statusEntrer: el.statusEntrer === "1" ? true : false,
                    statusPlat: el.statusPlat === "1" ? true : false,
                    statusDessert: el.statusDessert === "1" ? true : false,
                    statusAutre: el.statusAutre === "1" ? true : false,
                    introduire: el.introduire,
                    nomAutre: el.nomAutre,
                }
                ]);

            });


        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }




    const menuRestaurant = () => {
        setLoadData(true);
        AfficheMenuRestaurant(restaurant.id).then(function (response) {
            console.log('Restaurant menu =>', response.data.donner);
            setDescription(response.data.donner.description);
            setPlanUrl(response.data.donner.urlPlan);
            setPrecision(response.data.donner.precision);
            setPromotion(response.data.donner.promotions);
            setPromoSpecial(response.data.donner.promoSpecial);
            setCuisine(response.data.donner.typeCuisines);
            setSelectImage(response.data.donner.photos);
            setEntrerResto(response.data.donner.entrers);
            setPlatResto(response.data.donner.plats);
            setDessertResto(response.data.donner.desserts);
            setPrixMoyenne(response.data.donner.prixMoyenne);
            setBoisson(response.data.donner.boissons);
            setService(response.data.donner.serviceRestaurant);
            setPayement(response.data.donner.payements);
            setRegime(response.data.donner.regimeAlimentaires)
        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }





    const handleChangeStatusContenu = () => {
        setStatusContenuMenu(!statusContenuMenu);
        setErrorContenuMenu('');
    }

    const handlePlatMenu = (platMenu) => {
        setAutrePlatMenu({
            check: false,
            name: ''
        });
        if (statusContenuMenu === false) {
            setErrorContenuMenu('Active cette bloc menu pour ajouter son contenue !');
            setPlatMenu(platMenu);
            const timer = setTimeout(() => setErrorContenuMenu(''), 3000);
            return () => clearTimeout(timer);
        } else {
            setPlatMenu(platMenu);
            setErrorContenuMenu('');
        }
    }

    const handleAutrePlatMenu = (e) => {
        if (e.target.name === "check") {
            setPlatMenu("");
            setAutrePlatMenu({
                ...autrePlatMenu,
                [e.target.name]: !autrePlatMenu.check
            })
        } else {
            setPlatMenu("");
            setAutrePlatMenu({
                ...autrePlatMenu,
                'name': e.target.value,
                'check': true
            });
        }

    }
    const handleCheckAvecContenu = (id) => {
        setStatusContenuMenu(true);
        setAvecContenu((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }












    const handleStatusDisponible = () => {
        setStatusDisponible(!statusDisponible);
        setErrorDisponible('');
    }


    const handleMoment = (id) => {
        setStatusDisponible(true);
        setMoment((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }


    const handleDisponible = (id) => {
        setStatusDisponible(true);
        setDisponible((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });

    }

    const handleStatusIntroduire = (e) => {
        if (statusIntroduire === false) {
            setStatusIntroduire(true);
            setIntroduire(e.target.value);
        } else {
            setIntroduire(e.target.value);
            setErrorIntroduire("");
        }

    }


    const handleAddEntrer = () => {
        setStatusEntrer(true);
        const existeEntrer = dataEntrer.find((el) => el.name === entrer);
        if (existeEntrer) {
            setErrorEntrer('Données existe déjas !');
            const timer = setTimeout(() => setErrorEntrer(''), 3000);
            return () => clearTimeout(timer);
        } else {
            if (entrer === "") {
                setErrorEntrer('Données obligatoire !');
                if (dataEntrer.length === 0) {
                    setStatusEntrer(false);
                }
                const timer = setTimeout(() => setErrorEntrer(''), 3000);
                return () => clearTimeout(timer);
            } else {
                if (dataEntrer.length < 3) {
                    setStatusEntrer(true);
                    setEntrer('');
                    setDataEntrer([...dataEntrer, { name: entrer }]);
                    setErrorEntrer('');
                } else {
                    setErrorEntrer('Données max 3 !');
                    const timer = setTimeout(() => setErrorEntrer(''), 3000);
                    return () => clearTimeout(timer);
                }
            }
        }

    }
    const handleDeleteEntrer = (name) => {
        if (dataEntrer.length === 1) {
            setStatusEntrer(false);
            setDataEntrer(dataEntrer.filter((el) => el.name !== name));
        } else {
            setDataEntrer(dataEntrer.filter((el) => el.name !== name));
        }
    }


    const handleAddPlat = () => {
        setStatusPlat(true);
        const existePlat = dataPlat.find((el) => el.name === plat);
        if (existePlat) {
            setErrorPlat('Données existe déjas !');
            const timer = setTimeout(() => setErrorPlat(''), 3000);
            return () => clearTimeout(timer);
        } else {
            if (plat === "") {
                setErrorPlat('Données obligatoire !');
                if (dataPlat.length === 0) {
                    setStatusPlat(false);
                }
                const timer = setTimeout(() => setErrorPlat(''), 3000);
                return () => clearTimeout(timer);
            } else {
                if (dataPlat.length < 3) {
                    setStatusPlat(true);
                    setPlat('');
                    setDataPlat([...dataPlat, { name: plat }]);
                    setErrorPlat('');
                } else {
                    setErrorPlat('Données max 3 !');
                    const timer = setTimeout(() => setErrorPlat(''), 3000);
                    return () => clearTimeout(timer);
                }
            }
        }

    }
    const handleDeletePlat = (name) => {
        if (dataPlat.length === 1) {
            setStatusPlat(false);
            setDataPlat(dataPlat.filter((el) => el.name !== name));
        } else {
            setDataPlat(dataPlat.filter((el) => el.name !== name));
        }
    }


    const handleAddDessert = () => {
        setStatusDessert(true);
        const existeDessert = dataDessert.find((el) => el.name === dessert);
        if (existeDessert) {
            setErrorDessert('Données existe déjas !');
            const timer = setTimeout(() => setErrorDessert(''), 3000);
            return () => clearTimeout(timer);
        } else {
            if (dessert === "") {
                setErrorDessert('Données obligatoire !');
                if (dataDessert.length === 0) {
                    setStatusDessert(false);
                }
                const timer = setTimeout(() => setErrorDessert(''), 3000);
                return () => clearTimeout(timer);
            } else {
                if (dataDessert.length < 3) {
                    setStatusDessert(true);
                    setDessert('');
                    setDataDessert([...dataDessert, { name: dessert }]);
                    setErrorDessert('');
                } else {
                    setErrorDessert('Données max 3 !');
                    const timer = setTimeout(() => setErrorDessert(''), 3000);
                    return () => clearTimeout(timer);
                }
            }
        }

    }
    const handleDeleteDessert = (name) => {
        if (dataDessert.length === 1) {
            setStatusDessert(false);
            setDataDessert(dataDessert.filter((el) => el.name !== name));
        } else {
            setDataDessert(dataDessert.filter((el) => el.name !== name));
        }
    }




    const handleAddAutre = () => {
        setStatusAutre(true);
        const existeAutre = dataAutre.find((el) => el.name === autre);
        if (nomAutre === "") {
            setErrorAutre("Veuillez remplir le nom");
            const timer = setTimeout(() => setErrorAutre(''), 3000);
            return () => clearTimeout(timer);
        } else {
            if (existeAutre) {
                setErrorAutre(`${nomAutre} existe déjas !`);
                const timer = setTimeout(() => setErrorAutre(''), 3000);
                return () => clearTimeout(timer);
            } else {
                if (autre === "") {
                    setErrorAutre(`Veuillez remplir le champ ${nomAutre} !`);
                    if (dataAutre.length === 0) {
                        setStatusAutre(false);
                    }
                    const timer = setTimeout(() => setErrorAutre(''), 3000);
                    return () => clearTimeout(timer);
                } else {
                    if (dataAutre.length < 3) {
                        setStatusAutre(true);
                        setAutre('');
                        setDataAutre([...dataAutre, { name: autre }]);
                        setErrorAutre('');
                    } else {
                        setErrorAutre(`Données max 3 !`);
                        const timer = setTimeout(() => setErrorAutre(''), 3000);
                        return () => clearTimeout(timer);
                    }
                }
            }
        }
    }
    const handleDeleteAutre = (name) => {
        if (dataAutre.length === 1) {
            setStatusAutre(false);
            setDataAutre(dataAutre.filter((el) => el.name !== name));
        } else {
            setDataAutre(dataAutre.filter((el) => el.name !== name));
        }
    }


    const handleAddMenu = () => {
        const detectMoment = moment.filter((el) => el.check === true);
        const detectDisponible = disponible.filter((el) => el.check === true);

        if (data.length < 10) {


            if (libelleMenu === "" && prixMenu === "") {
                setErrorLibelleMenu('Libelle menu obligatoire');
                setErrorPrixMenu('Prix menu obligatoire');
                const timer = setTimeout(() => {
                    setErrorLibelleMenu('');
                    setErrorPrixMenu('');
                }, 3000);
                return () => clearTimeout(timer);
            } else if (libelleMenu !== "" && prixMenu === "") {

                setErrorPrixMenu('Prix menu obligatoire');
                const timer = setTimeout(() => {

                    setErrorPrixMenu('');
                }, 3000);
                return () => clearTimeout(timer);
            } else if (libelleMenu === "" && prixMenu !== "") {
                setErrorLibelleMenu('Libelle menu obligatoire');
                const timer = setTimeout(() => {
                    setErrorLibelleMenu('');
                }, 3000);
                return () => clearTimeout(timer);
            } else {
                if (platMenu === "" && autrePlatMenu.name === "") {
                    setErrorContenuMenu('Donner obligatoire');
                    const timer = setTimeout(() => {

                        setErrorContenuMenu('');
                    }, 3000);
                    return () => clearTimeout(timer);
                } else {
                    if (detectMoment.length === 0 || detectDisponible.length === 0) {
                        setErrorDisponible('Donner obligatoire');
                        const timer = setTimeout(() => {

                            setErrorDisponible('');
                        }, 3000);
                        return () => clearTimeout(timer);
                    } else {
                        const dataAvecContenu = avecContenu.filter((el) => el.check === true);
                        const dataMoment = moment.filter((el) => el.check === true);
                        const dataDisponible = disponible.filter((el) => el.check === true);

                        dataAvecContenu.map((el) => {
                            return setToutAvecContenu((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name, check: el.check }]);
                        });

                        dataMoment.map((el) => {
                            return setToutMoment((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name, check: el.check }]);
                        });

                        dataDisponible.map((el) => {
                            return setToutDisponible((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name, check: el.check }]);
                        });

                        dataEntrer.map((el) => {
                            return setToutEntrer((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name }]);
                        });

                        dataPlat.map((el) => {
                            return setToutPlat((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name }]);
                        });
                        dataDessert.map((el) => {
                            return setToutDessert((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name }]);
                        });
                        dataAutre.map((el) => {
                            return setToutAutre((prev) => [...prev, { idMenu: data.length + 1, id: uuidv4(), name: el.name }]);
                        });

                        setData((prev) => [...prev,
                        {
                            id: data.length + 1,
                            activeMenu: activeMenu,
                            libelleMenu: libelleMenu,
                            prixMenu: prixMenu,
                            statusContenuMenu: statusContenuMenu,
                            platMenu: platMenu,
                            autrePlatMenu: autrePlatMenu.name,
                            statusAutrePlatMenu: autrePlatMenu.check,
                            statusDisponible: statusDisponible,
                            statusReservant: statuReservant,
                            statusIntroduire: statusIntroduire,
                            statusEntrer: statusEntrer,
                            statusPlat: statusPlat,
                            statusDessert: statusDessert,
                            statusAutre: statusAutre,
                            introduire: introduire,
                            nomAutre: nomAutre,
                        }
                        ]);
                        setAutrePlatMenu({
                            check: false,
                            name: ""
                        });
                        setAvecContenu((prev) => {
                            return prev.map((el) => { return { ...el, check: false } });
                        });
                        setAvecContenu((prev) => {
                            return prev.map((el) => {
                                if (el.id === 3) {
                                    return { ...el, name: "" }
                                } else {
                                    return { ...el };
                                }
                            });
                        });
                        setMoment((prev) => {
                            return prev.map((el) => { return { ...el, check: false } });
                        });
                        setDisponible((prev) => {
                            return prev.map((el) => { return { ...el, check: false } });
                        });

                        toast.success('Création menu avec success');
                        setAutrePlatMenu({
                            check: false,
                            name: ""
                        });
                        setActiveForm(false);
                        setLibelleMenu('');
                        setPrixMenu('');
                        setPlatMenu('');
                        setIntroduire('');
                        setEntrer('');
                        setDataEntrer([]);
                        setPlat('');
                        setDataPlat([]);
                        setDessert('');
                        setDataDessert([]);
                        setNomAutre('');
                        setDataAutre([]);
                        setErrorAutre('');
                        setStatusIntroduire(false);
                        setStatusEntrer(false);
                        setStatusDessert(false);
                        setStatusPlat(false);
                        setStatuReservant(false);
                        setStatusAutre(false);
                        setErrorContenuMenu('');
                        setErrorDessert('');
                        setErrorDisponible('');
                        setErrorEntrer('');
                        setErrorIntroduire('');
                        setErrorPlat('');
                        setAjouteMenu(false);
                    }
                }


            }
        } else {
            toast.warning('Ajoute Menu max 10');
        }

    }


    const handleAnnuler = () => {
        if (data.length !== 0) {
            setActiveForm(false);
        }
        setLibelleMenu('');
        setErrorLibelleMenu('');
        setPrixMenu('');
        setPlatMenu('');
        setIntroduire('');
        setEntrer('');
        setDataEntrer([]);
        setPlat('');
        setDataPlat([]);
        setDessert('');
        setDataDessert([]);
        setNomAutre('');
        setDataAutre([]);
        setActiveForm(false);
        setPrixMenu('');
        setPlatMenu('');
        setIntroduire('');
        setEntrer('');
        setDataEntrer([]);
        setPlat('');
        setDataPlat([]);
        setStatusIntroduire(false);
        setStatusEntrer(false);
        setStatusDessert(false);
        setStatusPlat(false);
        setStatusAutre(false);
        setStatuReservant(false);
        setDessert('');
        setDataDessert([]);
        setNomAutre('');
        setDataAutre([]);
        setErrorAutre('');
        setErrorContenuMenu('');
        setErrorDessert('');
        setErrorDisponible('');
        setErrorEntrer('');
        setErrorIntroduire('');
        setErrorPlat('');


        setAvecContenu((prev) => {
            return prev.map((el) => { return { ...el, check: false } });
        });
        setMoment((prev) => {
            return prev.map((el) => { return { ...el, check: false } });
        });
        setDisponible((prev) => {
            return prev.map((el) => { return { ...el, check: false } });
        });

        setData([]);
        setToutAvecContenu([]);
        setToutMoment([]);
        setToutDisponible([]);
        setToutEntrer([]);
        setToutPlat([]);
        setToutDessert([]);
        setToutAutre([]);
        Menu();
    }
















    // ========================================= UPDATE MENU LISTE



    const handleChangeMenu = (id) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, activeMenu: !item.activeMenu };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleUpdateLibelleMenu = (e, id) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, libelleMenu: e.target.value };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleUpdatePrixMenu = (e, id) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, prixMenu: e.target.value };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleDeleteMenu = (id) => {

        setToutAvecContenu(toutAvecContenu.filter((el) => el.idMenu !== id));
        setToutDisponible(toutDisponible.filter((el) => el.idMenu !== id));
        setToutMoment(toutMoment.filter((el) => el.idMenu !== id));
        setToutEntrer(toutEntrer.filter((el) => el.idMenu !== id));
        setToutPlat(toutPlat.filter((el) => el.idMenu !== id));
        setToutDessert(toutDessert.filter((el) => el.idMenu !== id));
        setToutAutre(toutAutre.filter((el) => el.idMenu !== id));

        setData(data.filter((el) => el.id !== id));
        toast.success('Supréssion menu avec success');
        setAjouteMenu(true);

    }


    const handleUpdateStatusContenu = (id) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, statusContenuMenu: !item.statusContenuMenu };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleUpdatePlatMenu = (value, id) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, platMenu: value, statusAutrePlatMenu: false, autrePlatMenu: '' };
                } else {
                    return { ...item };
                }
            });
        });
    }











    const AvecContenuView = (idMenu) => {
        const avecContenuMenu = toutAvecContenu.filter((el) => el.idMenu === idMenu);
        const existe1 = avecContenuMenu.find((el) => el.name === avecContenu[0].name);
        const existe2 = avecContenuMenu.find((el) => el.name === avecContenu[1].name);
        return (
            <form>
                <div className='check mt-2'>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" name="avec contenu" onChange={() => handleUpdateAvecContenu(idMenu, avecContenu[0].name)} checked={existe1 ? true : false} id={avecContenu[0].name + idMenu} />
                        <label className="form-check-label" htmlFor={avecContenu[0].name + idMenu}> + {avecContenu[0].name}  </label>
                    </div>

                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" name="avec contenu" onChange={() => handleUpdateAvecContenu(idMenu, avecContenu[1].name)} checked={existe2 ? true : false} id={avecContenu[1].name + idMenu} />
                        <label className="form-check-label" htmlFor={avecContenu[1].name + idMenu}> + {avecContenu[1].name}  </label>
                    </div>

                </div>

            </form>
        );
    }


    const handleUpdateStatusAutrePlatMenu = (id, statusAutrePlatMenu) => {
        if (statusAutrePlatMenu === false) {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        return { ...item, statusAutrePlatMenu: !item.statusAutrePlatMenu, platMenu: "" };
                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        return { ...item, statusAutrePlatMenu: !item.statusAutrePlatMenu, autrePlatMenu: "" };
                    } else {
                        return { ...item };
                    }
                });
            });
        }

    }

    const handleUpdateAutrePlatMenu = (id, name) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, statusAutrePlatMenu: true, autrePlatMenu: name, platMenu: "" };
                } else {
                    return { ...item };
                }
            });
        });
    }


    const handleUpdateAvecContenu = (idMenu, nameExiste) => {
        const existeAvecContenu = toutAvecContenu.find((el) => el.idMenu === idMenu && el.name === nameExiste);
        console.log("existe", existeAvecContenu);
        if (existeAvecContenu) {
            setToutAvecContenu(toutAvecContenu.filter((el) => el.id !== existeAvecContenu.id));
        } else {
            setToutAvecContenu((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: nameExiste, check: true }]);
        }
    }









    const momentView = (idMenu) => {
        const DataMoment = toutMoment.filter((el) => el.idMenu === idMenu);
        return (
            <form>
                <div className='check'>
                    {moment.map((moment, index) => {
                        const existMoment = DataMoment.find((el) => el.name === moment.name);
                        return (
                            <div className="form-check form-check-inline" key={index}>
                                <input className="form-check-input" type="checkbox" name='moment' value={moment.name} defaultChecked={existMoment ? true : false} onChange={() => handleUpdateMoment(moment.name, existMoment?.id, idMenu)} id={moment.name + idMenu} />
                                <label className="form-check-label" htmlFor={moment.name + idMenu}> au {moment.name}</label>
                            </div>
                        )
                    })}
                </div>

            </form>
        );
    }

    const handleUpdateMoment = (nameMoment, idMoment, idMenu) => {
        const existeMoment = toutMoment.find((el) => el.id === idMoment);
        if (existeMoment) {
            setToutMoment(toutMoment.filter((el) => el.id !== idMoment));
        } else {
            setToutMoment((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: nameMoment, check: true }]);
        }
    }





    const handleUpdateStatusDisponible = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusDisponible: !item.statusDisponible };
                } else {
                    return { ...item };
                }
            });
        })
    }




    const disponibleView = (idMenu) => {
        const dataDisponible = toutDisponible.filter((el) => el.idMenu === idMenu);
        return (
            <form>
                <div className='check mt-2'>
                    <div className="form-check-inline">
                        <label className="form-check-label">Les</label>
                    </div>
                    {disponible.map((disponible, index) => {
                        const existeDisponible = dataDisponible.find((el) => el.name === disponible.name);
                        return (
                            <div className="form-check form-check-inline" key={index}>
                                <input className="form-check-input" type="checkbox" value={disponible.name} name="disponible" defaultChecked={existeDisponible ? true : false} onChange={() => handleUpdateDisponible(disponible.name, existeDisponible?.id, idMenu)} id={disponible.name + idMenu} />
                                <label className="form-check-label" htmlFor={disponible.name + idMenu} > {disponible.name}  </label>
                            </div>
                        );
                    })}
                </div>

            </form>
        )
    }


    const handleUpdateDisponible = (nameDisponible, idDisponible, idMenu) => {
        const existDisponible = toutDisponible.find((el) => el.id === idDisponible);
        if (existDisponible) {
            setToutDisponible(toutDisponible.filter((el) => el.id !== idDisponible));
        } else {
            setToutDisponible((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: nameDisponible, check: true }]);
        }
    }


    const handleUpdateStatuReservant = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusReservant: !item.statusReservant };
                } else {
                    return { ...item };
                }
            });
        })
    }

    const handleUpdateStatusIntroduire = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusIntroduire: !item.statusIntroduire };
                } else {
                    return { ...item };
                }
            });
        })
    }

    const handleUpdateIntroduire = (value, idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, introduire: value, statusIntroduire: true };
                } else {
                    return { ...item };
                }
            });
        })
    }





    const entrerView = (id) => {
        const donnerEntrer = toutEntrer.filter((el) => el.idMenu === id);
        return (
            donnerEntrer?.length !== 0 ?
                donnerEntrer.map((el, index) => {
                    return (
                        <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                            <h4>{el.name}</h4>
                            <div className='menu_carte_button'>
                                <button className="btn btn_delete btn-sm" onClick={() => handleUpdateDeleteEntrer(el.id, id)}><i className='fa fa-trash'></i></button>
                            </div>
                        </div>
                    );
                }) : <p>Entreés vide ...</p>
        )
    }

    const handleUpdateDeleteEntrer = (id, idMenu) => {
        const donnerToutEntrer = toutEntrer.filter((el) => el.idMenu === idMenu);
        if (donnerToutEntrer.length === 1) {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusEntrer: false };
                    } else {
                        return { ...item };
                    }
                });
            });
            setToutEntrer(toutEntrer.filter((el) => el.id !== id));
        } else {
            setToutEntrer(toutEntrer.filter((el) => el.id !== id));
        }
    }


    const handleAddUpdateEntrer = (idMenu) => {
        if (updateEntrer !== '') {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusEntrer: true };
                    } else {
                        return { ...item };
                    }
                });
            });
            setUpdateEntrer('');
            setToutEntrer((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: updateEntrer }]);
        }
    }








    const viewPlat = (id) => {
        const donnerPlat = toutPlat.filter((el) => el.idMenu === id);
        return (
            donnerPlat?.length !== 0 ? donnerPlat.map((el, index) => {
                return (
                    <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                        <h4>{el.name}</h4>
                        <div className='menu_carte_button'>

                            <button className="btn btn_delete btn-sm" onClick={() => handleUpdateDeletePlat(el.id, id)}><i className='fa fa-trash'></i></button>
                        </div>
                    </div>
                );
            }) : <p>Plats vide...</p>
        )
    }

    const handleUpdateDeletePlat = (id, idMenu) => {
        const donnerToutPlat = toutPlat.filter((el) => el.idMenu === idMenu);

        if (donnerToutPlat.length === 1) {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusPlat: false };
                    } else {
                        return { ...item };
                    }
                });
            });
            setToutPlat(toutPlat.filter((el) => el.id !== id));
        } else {
            setToutPlat(toutPlat.filter((el) => el.id !== id));
        }
    }

    const handleAddUpdatePlat = (idMenu) => {
        if (updatePlat !== '') {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusPlat: true };
                    } else {
                        return { ...item };
                    }
                });
            });
            setUpdatePlat('');
            setToutPlat((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: updatePlat }])
        }

    }



    const viewDessert = (id) => {
        const donnerDessert = toutDessert.filter((el) => el.idMenu === id);
        return (
            donnerDessert?.length !== 0 ? donnerDessert.map((el, index) => {
                return (
                    <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                        <h4>{el.name}</h4>
                        <div className='menu_carte_button'>

                            <button className="btn btn_delete btn-sm" onClick={() => handleUpdateDeleteDessert(el.id, id)}><i className='fa fa-trash'></i></button>
                        </div>
                    </div>
                );
            }) : <p>Dessert vide...</p>
        )
    }


    const handleUpdateDeleteDessert = (id, idMenu) => {
        const donnerToutDessert = toutDessert.filter((el) => el.idMenu === idMenu);

        if (donnerToutDessert.length === 1) {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusDessert: false };
                    } else {
                        return { ...item };
                    }
                });
            });
            setToutDessert(toutDessert.filter((el) => el.id !== id));
        } else {
            setToutDessert(toutDessert.filter((el) => el.id !== id));
        }
    }



    const handleUpdateAddDessert = (idMenu) => {
        if (updateDessert !== '') {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusDessert: true };
                    } else {
                        return { ...item };
                    }
                });
            });
            setUpdateDessert('');
            setToutDessert((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: updateDessert }]);
        }
    }





    const handleUpdateNomAutre = (idMenu, value) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, nomAutre: value };
                } else {
                    return { ...item };
                }
            });
        });
    }




    const viewAutre = (id) => {
        const donnerAutre = toutAutre.filter((el) => el.idMenu === id);
        return (
            donnerAutre?.length !== 0 ? donnerAutre.map((el, index) => {
                return (
                    <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                        <h4>{el.name}</h4>
                        <div className='menu_carte_button'>

                            <button className="btn btn_delete btn-sm" onClick={() => handleUpdateDeleteAutre(el.id, id)}><i className='fa fa-trash'></i></button>
                        </div>
                    </div>
                );
            }) : <p>Données vide...</p>
        );
    }



    const handleUpdateDeleteAutre = (id, idMenu) => {
        const donnerToutAutre = toutAutre.filter((el) => el.idMenu === idMenu);

        if (donnerToutAutre.length === 1) {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusAutre: false };
                    } else {
                        return { ...item };
                    }
                });
            });
            setToutAutre(toutAutre.filter((el) => el.id !== id));
        } else {
            setToutAutre(toutAutre.filter((el) => el.id !== id));
        }
    }


    const handleUpdateAddAutre = (idMenu) => {
        if (updateAutre !== "") {
            setData((prev) => {
                return prev.map((item) => {
                    if (item.id === idMenu) {
                        return { ...item, statusAutre: true };
                    } else {
                        return { ...item };
                    }
                });
            });
            setUpdateAutre('');
            setToutAutre((prev) => [...prev, { idMenu: idMenu, id: uuidv4(), name: updateAutre }]);
        }
    }





    const handleUpdateStatusEntrer = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusEntrer: !item.statusEntrer };
                } else {
                    return { ...item };
                }
            });
        });
    }



    const handleUpdateStatusPlat = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusPlat: !item.statusPlat };
                } else {
                    return { ...item };
                }
            });
        });
    }


    const handleUpdateStatusDessert = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusDessert: !item.statusDessert };
                } else {
                    return { ...item };
                }
            });
        });
    }





    const handleStatusAutre = (idMenu) => {
        setData((prev) => {
            return prev.map((item) => {
                if (item.id === idMenu) {
                    return { ...item, statusAutre: !item.statusAutre };
                } else {
                    return { ...item };
                }
            });
        });
    }







    const handleClose = () => setShowModal(false);
    const handleShow = (breakpoint) => {
        setFullscreen(breakpoint);
        setShowModal(true);
    };


    console.log("data =>", data);
    console.log("toutAvecContenu =>", toutAvecContenu);
    console.log("toutMoment =>", toutMoment);
    console.log("toutDisponible =>", toutDisponible);
    console.log("toutEntrer =>", toutEntrer);
    console.log("toutPlat =>", toutPlat);
    console.log("toutDessert =>", toutDessert);
    console.log("toutAutre =>", toutAutre);






    const handlePublier = () => {
        if(!localStorage.getItem('tokenSociete')){
        setLoading(true);
        const menus = { idRestaurant: restaurant.id, menus: data, avecContenu: toutAvecContenu, moment: toutMoment, jour: toutDisponible, entrerMenu: toutEntrer, platMenu: toutPlat, dessertMenu: toutDessert, autreMenu: toutAutre };
        AjouteMenu(menus).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
                setData([]);
                setToutAvecContenu([]);
                setToutMoment([]);
                setToutDisponible([]);
                setToutEntrer([]);
                setToutPlat([]);
                setToutDessert([]);
                setToutAutre([]);
                Menu();
            }
        }).catch(function (error) {
            console.log(error.response);
            toast.warning(error.response.data.message);
        }).finally(function () {
            setLoading(false);
        });
    }else{
        toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
    }




    const plural = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    }

    const viewDate = (value) => {
        const date = new Date(value);
        return plural(date.getDate()) + "/" + plural(parseInt(date.getUTCMonth() + 1)) + "/" + date.getFullYear();
    }



    const viewAvisListe = (item, index) => {
        const nom = item.client.nom.charAt(0).toUpperCase();
        const prenom = item.client.prenom.charAt(0).toUpperCase();
        const clientAvis = restaurant.avis.filter((el) => el.client.id === item.client.id);
        return (
            <div className='resto_avis_liste' key={index}>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                        <div className='resto_avis_profile'>
                            <div className='resto_avatar_client'>
                                {
                                    item.client.sexe === "Homme" ? <img src={Avatar2} alt="avatar client" /> : <img src={Avatar1} alt="avatar client" />
                                }
                            </div>
                            {item.client.affichagePseudo === "1" ?
                                <div className='pseudoClient d-flex flex-column'>
                                    <span>{item.client.nom}</span>
                                    <span className='text-center'>{item.client.prenom}</span>
                                </div>
                                : item.client.affichagePseudo === "2" ?
                                    <span>{item.client.prenom} {nom}</span>
                                    : item.client.affichagePseudo === "3" ?
                                        <span>{prenom} {item.client.prenom}</span>
                                        : <span>{nom} {prenom}</span>}
                        </div>
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                        <div className='resto_note_avis'>
                            <div className='d-flex justify-content-center'>
                                <div className='note_avis_content'>
                                    <div>
                                        <div className='resto_note_value'>Note/<span>{item.notes[0]?.note}</span></div>
                                        <div className='resto_avis_value'>Avis/<span>{clientAvis.length}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className='resto_avis_date'>
                                <span>{viewDate(item.createdAt)}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <div className='resto_content_avis'>
                            <p>{item.avis}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div>
            <Helmet>
                <title>Menus</title>
                <meta name='description' content='Restaurant menus.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='menu'>
                <div className='container'>
                    <div className='menu_titre'>
                        <div className='titre'>
                            <div className='d-flex'>
                                <i className='fa fa-list-alt'></i><h1>Menus</h1>
                            </div>
                        </div>
                        <div className='description_titre'>
                            <p>Il n’est pas obligatoire de donner des exemples composant le menu, mais également souhaitable. N’y indiquer que quelques plats « alléchants ».
                                Pour chaque menu activé, le prix sera à renseigner obligatoirement et automatiquement affiché dans la fiche  Resto..
                                Veillez à mettre à jour cette page lors de vos changements de carte – plats et/ou prix
                            </p>
                            <div className='d-flex justify-content-end'>
                                <div className='d-flex flex_button_action'>
                                    {data.length !== 0 || ajouterMenu === true ? <button className='btn btn_action' onClick={() => setActiveForm(true)}>Ajoute un menu</button> : ""}
                                    {data.length !== 0 && activeForm === true ? <button className='btn btn_action' onClick={handleAnnuler}>Annuler</button> : ""}
                                    <button className='btn btn_action' onClick={() => handleShow(true)}>Visualiser</button>
                                    {loading ? <Button className='btn btn_ajouteMenu' disabled>
                                        <Spinner

                                            animation="border"
                                            size="sm"
                                            variant="info"
                                        />
                                        Loading...
                                    </Button> : <button className='btn btn_action' onClick={handlePublier}>Publier</button>}

                                </div>
                            </div>
                        </div>
                    </div>
                    {activeForm ? <div className='liste_menu'>
                        <div className='d-flex justify-content-between'>
                            <div className='d-flex form_menu_flex'>
                                <div className='le_menu'>
                                    <input type="text" value={libelleMenu} onChange={(e) => setLibelleMenu(e.target.value)} className='form-control form-control-sm' placeholder='Menu ...' />
                                    {errorLibelleMenu !== "" ? <span className="errorValue">{errorLibelleMenu}</span> : ''}
                                </div>
                                <h2 className="ms-2">à</h2>
                                <div>
                                    <input type="number" onKeyDown={blockInvalidChar} value={prixMenu} onChange={(e) => setPrixMenu(e.target.value)} className='form-control form-control-sm' placeholder='Prix ...' />
                                    {errorPrixMenu !== "" ? <span className="errorValue">{errorPrixMenu}</span> : ''}
                                </div>
                                <h2 className='ms-2'>Ar</h2>
                            </div>
                        </div>

                        <div className='content_menu'>
                            <div className='d-flex'>
                                <Form.Check
                                    type="switch"
                                    name="status"
                                    checked={statusContenuMenu}
                                    onChange={handleChangeStatusContenu}
                                    id="custom2"
                                    className='mt-2'

                                />
                                <h3>Ce menu comprend :</h3>
                                {errorContenuMenu !== "" ? <span className="errorValue ms-2 mt-2">{errorContenuMenu}</span> : ''}
                            </div>
                            <form>
                                <div className='check'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Entrée + Plat")} id="radio1" />
                                        <label className="form-check-label" htmlFor="radio1">
                                            Entrée + Plat
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Plat + Dessert" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Plat + Dessert")} id="radio2" />
                                        <label className="form-check-label" htmlFor="radio2">
                                            Plat + Dessert
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat ou Plat + Dessert" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Entrée + Plat ou Plat + Dessert")} id="radio3" />
                                        <label className="form-check-label" htmlFor="radio3">
                                            Entrée + Plat ou Plat + Dessert
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat + Dessert" ? true : false} value={platMenu} id="radio4" onChange={() => handlePlatMenu("Entrée + Plat + Dessert")} />
                                        <label className="form-check-label" htmlFor="radio4">
                                            Entrée + Plat + Dessert

                                        </label>
                                    </div>
                                </div>

                            </form>
                            <form>
                                <div className='check mt-2'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" value={avecContenu[0].name} name="avec contenu" checked={avecContenu[0].check} id={avecContenu[0].name} onChange={() => handleCheckAvecContenu(avecContenu[0].id)} />
                                        <label className="form-check-label" htmlFor={avecContenu[0].name}> + {avecContenu[0].name}  </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" value={avecContenu[1].name} name="avec contenu" checked={avecContenu[1].check} id={avecContenu[1].name} onChange={() => handleCheckAvecContenu(avecContenu[1].id)} />
                                        <label className="form-check-label" htmlFor={avecContenu[1].name}> + {avecContenu[1].name}  </label>
                                    </div>

                                </div>

                            </form>
                            <form>
                                <div className='check mt-2'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="check" onChange={handleAutrePlatMenu} checked={autrePlatMenu.check} id={autrePlatMenu.name} />
                                        <input type="text" className="form-control form-control-sm" name="name" value={autrePlatMenu.name} onChange={handleAutrePlatMenu} placeholder=" ex : plat du jour + Boisson ..." />
                                    </div>

                                </div>

                            </form>
                            <div className='d-flex'>
                                <Form.Check
                                    type="switch"
                                    id="custom3"
                                    name="status"
                                    checked={statusDisponible}
                                    onChange={(e) => handleStatusDisponible()}
                                    className='mt-2'
                                />
                                <h3>Ce menu est disponible :</h3>
                                {errorDisponible !== "" ? <span className="errorValue ms-2 mt-2">{errorDisponible}</span> : ''}
                            </div>

                            <form>
                                <div className='check'>
                                    {moment.map((moment, index) => {
                                        return (
                                            <div className="form-check form-check-inline" key={index}>
                                                <input className="form-check-input" type="checkbox" name='moment' value={moment.name} defaultChecked={moment.check} onChange={() => handleMoment(moment.id)} id={moment.name} />
                                                <label className="form-check-label" htmlFor={moment.name}> au {moment.name}</label>
                                            </div>
                                        )
                                    })}
                                </div>

                            </form>
                            <form>
                                <div className='check mt-2'>
                                    <div className="form-check-inline">
                                        <label className="form-check-label">Les</label>
                                    </div>
                                    {disponible.map((disponible, index) => {
                                        return (
                                            <div className="form-check form-check-inline" key={index}>
                                                <input className="form-check-input" type="checkbox" value={disponible.name} name="disponible" defaultChecked={disponible.check} onChange={() => handleDisponible(disponible.id)} id={disponible.name} />
                                                <label className="form-check-label" htmlFor={disponible.name} > {disponible.name}  </label>
                                            </div>
                                        );
                                    })}
                                </div>

                            </form>
                            <div className='d-flex'>
                                <Form.Check
                                    type="switch"
                                    defaultChecked={statuReservant}
                                    onChange={() => setStatuReservant(!statuReservant)}
                                    id="custom4"
                                    className='mt-2'

                                />
                                <h3 className='remarque'>En réservant avec ce menu, vous pouvez, une fois sur place, soit bénéficier de ce menu, soit commander à la carte si vous changez d’avis </h3>
                            </div>
                            <h3 className='details'>Détails</h3>
                            <div className='d-flex'>
                                <Form.Check
                                    type="switch"
                                    id="custom5"
                                    checked={statusIntroduire}
                                    onChange={() => setStatusIntroduire(!statusIntroduire)}
                                    className='mt-2'

                                />
                                <input className='form-control introduire' value={introduire} onChange={(e) => handleStatusIntroduire(e)} placeholder="Pour introduire le menu. Exemple : « Au choix parmi : », « Le chef … vous propose son menu dégustation à partager à deux ou à plusieurs ..." />
                            </div>
                            {errorIntroduire !== "" ?
                                <span className="errorValue">{errorIntroduire}</span> : ''}
                            <div className='menu_carte mt-5'>
                                <div className='row'>
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                        <div className="menu_carte_item">
                                            <div className='d-flex justify-content-between header_item'>
                                                <h3 className='details'>Entrée</h3>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom5"
                                                    checked={statusEntrer}
                                                    onChange={() => setStatusEntrer(!statusEntrer)}
                                                    className='mt-2'

                                                />
                                            </div>
                                            <div className='d-flex mt-2'>
                                                <input type="text" value={entrer} onChange={(e) => setEntrer(e.target.value)} className='form-control form-control-sm' placeholder='Entrée ...' />
                                                <button type="button" className='btn btn-sm' onClick={handleAddEntrer}><i className="fa fa-plus"></i></button>
                                            </div>
                                            {errorEntrer !== "" ?
                                                <span className="errorValue">{errorEntrer}</span> : ''}
                                            {dataEntrer?.length !== 0 ?
                                                dataEntrer.map((el, index) => {
                                                    return (
                                                        <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                                                            <h4>{el.name}</h4>
                                                            <div className='menu_carte_button'>
                                                                <button className="btn btn_delete btn-sm" onClick={() => handleDeleteEntrer(el.name)}><i className='fa fa-trash'></i></button>
                                                            </div>
                                                        </div>
                                                    );
                                                }) : <p>Entreés vide ...</p>}

                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                        <div className="menu_carte_item">
                                            <div className="d-flex justify-content-between header_item">
                                                <h3 className='details'>Plats</h3>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom5"
                                                    checked={statusPlat}
                                                    onChange={() => setStatusPlat(!statusPlat)}
                                                    className='mt-2'

                                                />
                                            </div>
                                            <div className='d-flex mt-2'>
                                                <input type="text" value={plat} onChange={(e) => setPlat(e.target.value)} className='form-control form-control-sm' placeholder='Plats ...' />
                                                <button type="button" className='btn btn-sm' onClick={handleAddPlat}><i className='fa fa-plus'></i></button>
                                            </div>
                                            {errorPlat !== "" ?
                                                <span className="errorValue">{errorPlat}</span> : ''}
                                            {dataPlat?.length !== 0 ? dataPlat.map((el, index) => {
                                                return (
                                                    <div className='d-flex justify-content-between data_liste mt-3' key={index}>
                                                        <h4>{el.name}</h4>
                                                        <div className='menu_carte_button'>

                                                            <button className="btn btn_delete btn-sm" onClick={() => handleDeletePlat(el.name)}><i className='fa fa-trash'></i></button>
                                                        </div>
                                                    </div>
                                                );
                                            }) : <p>Plats vide...</p>}
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                        <div className="menu_carte_item">
                                            <div className='d-flex justify-content-between header_item'>
                                                <h3 className='details'>Dessert</h3>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom5"
                                                    checked={statusDessert}
                                                    onChange={() => setStatusDessert(!statusDessert)}
                                                    className='mt-2'
                                                />
                                            </div>
                                            <div className='d-flex mt-2'>
                                                <input type="text" value={dessert} onChange={(e) => setDessert(e.target.value)} className='form-control form-control-sm' placeholder='Dessert ...' />
                                                <button type="button" className='btn btn-sm' onClick={handleAddDessert}><i className='fa fa-plus'></i></button>
                                            </div>
                                            {errorDessert !== "" ?
                                                <span className="errorValue">{errorDessert}</span> : ''}
                                            {dataDessert?.length !== 0 ? dataDessert.map((el, index) => {
                                                return (
                                                    <div className='d-flex justify-content-between data_liste mt-3' key={index}>
                                                        <h4>{el.name}</h4>
                                                        <div className='menu_carte_button'>

                                                            <button className="btn btn_delete btn-sm" onClick={() => handleDeleteDessert(el.name)}><i className='fa fa-trash'></i></button>
                                                        </div>
                                                    </div>
                                                );
                                            }) : <p>Dessert vide...</p>}

                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                        <div className="menu_carte_item">

                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom5"
                                                    checked={statusAutre}
                                                    onChange={() => setStatusAutre(!statusAutre)}
                                                    className='mt-2'

                                                />
                                                <input type="text" value={nomAutre} onChange={(e) => setNomAutre(e.target.value)} className='form-control form-control-sm' placeholder='Nom ...' />
                                            </div>
                                            <div className='d-flex mt-2'>
                                                <input type="text" value={autre} onChange={(e) => setAutre(e.target.value)} className='form-control form-control-sm' placeholder='Item ...' />
                                                <button type="submit" className='btn btn-sm' onClick={handleAddAutre}><i className='fa fa-plus'></i></button>
                                            </div>
                                            {errorAutre !== "" ?
                                                <span className="errorValue">{errorAutre}</span> : ''}
                                            {dataAutre?.length !== 0 ? dataAutre.map((el, index) => {
                                                return (
                                                    <div className='d-flex justify-content-between data_liste  mt-3' key={index}>
                                                        <h4>{el.name}</h4>
                                                        <div className='menu_carte_button'>
                                                            <button className="btn btn_delete btn-sm" onClick={() => handleDeleteAutre(el.name)}><i className='fa fa-trash'></i></button>
                                                        </div>
                                                    </div>
                                                );
                                            }) : <p>Données vide...</p>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex mt-2'>
                                <Form.Check
                                    type="switch"
                                    id="custom6"
                                    className='mt-2'
                                    defaultChecked="true"
                                />
                                <h3 className='remarque'>Ce menu est seulement indicatif et les plats listés ci-dessus peuvent changer en fonction des arrivages.</h3>
                            </div>
                        </div>
                        <div className='action_menu'>
                            <div className='d-flex justify-content-center'>
                                <button className='btn btn_valider' onClick={handleAddMenu}>Ajouter</button>
                            </div>
                        </div>
                        <p className='version'>Version 1</p>
                    </div> : ''}

                    {/* ========================= FIN  FORM MENU ========================= */}










                    {/* ========================= BOUCLE MENU  ============================ */}


                    {loadData === true ? <div className="d-flex justify-content-center">
                        <Spinner animation="border" className="load" variant="info" size="md" />
                    </div> :
                        data?.length !== 0 ?
                            data.map((menu, index) => {
                                return (
                                    <div className='boucle_menu' key={index}>
                                        <div className='d-flex justify-content-between boucle_menu_header'>
                                            <div className='d-flex header_menu_flex'>
                                                <div className='le_menu'>
                                                    <input type="text" value={menu.libelleMenu} onChange={(e) => handleUpdateLibelleMenu(e, menu.id)} className='form-control form-control-sm' placeholder='Menu ...' />
                                                </div>
                                                <h2 className='ms-2'>à</h2>
                                                <input type="number" onKeyDown={blockInvalidChar} value={menu.prixMenu} onChange={(e) => handleUpdatePrixMenu(e, menu.id)} className='form-control form-control-sm' placeholder='Prix ...' />
                                                <h2 className='ms-2'>Ar</h2>
                                            </div>
                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    name="status"
                                                    checked={menu.activeMenu}
                                                    onChange={() => handleChangeMenu(menu.id)}
                                                    id="custom2"
                                                    label="Afficher le menu"
                                                    className='mt-2 active_menu'

                                                />
                                                <span className='delete_Menu' onClick={() => handleDeleteMenu(menu.id)}><i className='fa fa-trash-o'></i></span>
                                            </div>
                                        </div>
                                        <div className='content_menu'>
                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    name="status"
                                                    checked={menu.statusContenuMenu}
                                                    onChange={() => handleUpdateStatusContenu(menu.id)}
                                                    id="custom2"
                                                    className='mt-2'

                                                />
                                                <h3>Ce menu comprend :</h3>
                                            </div>
                                            <form>
                                                <div className='check'>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="contenu" value={menu.platMenu} checked={menu.platMenu === "Entrée + Plat" ? true : false} onChange={() => handleUpdatePlatMenu("Entrée + Plat", menu.id)} id={menu.id + "radio1"} />
                                                        <label className="form-check-label" htmlFor={menu.id + "radio1"}>
                                                            Entrée + Plat
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="contenu" value={menu.platMenu} checked={menu.platMenu === "Plat + Dessert" ? true : false} onChange={() => handleUpdatePlatMenu("Plat + Dessert", menu.id)} id={menu.id + "radio2"} />
                                                        <label className="form-check-label" htmlFor={menu.id + "radio2"}>
                                                            Plat + Dessert
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="contenu" value={menu.platMenu} checked={menu.platMenu === "Entrée + Plat ou Plat + Dessert" ? true : false} onChange={() => handleUpdatePlatMenu("Entrée + Plat ou Plat + Dessert", menu.id)} id={menu.id + "radio3"} />
                                                        <label className="form-check-label" htmlFor={menu.id + "radio3"}>
                                                            Entrée + Plat ou Plat + Dessert
                                                        </label>
                                                    </div>

                                                </div>

                                            </form>

                                            {AvecContenuView(menu.id)}
                                            <form>
                                                <div className='check mt-2'>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="checkbox" name="check" onChange={() => handleUpdateStatusAutrePlatMenu(menu.id, menu.statusAutrePlatMenu)} checked={menu.statusAutrePlatMenu} id={menu.autrePlatMenu + menu.id} />
                                                        <input type="text" className="form-control form-control-sm" name="name" value={menu.autrePlatMenu} onChange={(e) => handleUpdateAutrePlatMenu(menu.id, e.target.value)} placeholder=" ex : plat du jour + Boisson ..." />
                                                    </div>

                                                </div>
                                            </form>
                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom3"
                                                    name="status"
                                                    checked={menu.statusDisponible}
                                                    onChange={(e) => handleUpdateStatusDisponible(menu.id)}
                                                    className='mt-2'
                                                />
                                                <h3>Ce menu est disponible :</h3>
                                            </div>


                                            {momentView(menu.id)}

                                            {disponibleView(menu.id)}



                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    checked={menu.statusReservant}
                                                    onChange={() => handleUpdateStatuReservant(menu.id)}
                                                    id="custom4"
                                                    className='mt-2'

                                                />
                                                <h3 className='remarque'>En réservant avec ce menu, vous pouvez, une fois sur place, soit bénéficier de ce menu, soit commander à la carte si vous changez d’avis </h3>
                                            </div>
                                            <h3 className='details'>Détails</h3>
                                            <div className='d-flex'>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom5"
                                                    checked={menu.statusIntroduire}
                                                    onChange={() => handleUpdateStatusIntroduire(menu.id)}
                                                    className='mt-2'

                                                />
                                                <input className='form-control introduire' value={menu.introduire} onChange={(e) => handleUpdateIntroduire(e.target.value, menu.id)} placeholder="Pour introduire le menu. Exemple : « Au choix parmi : », « Le chef … vous propose son menu dégustation à partager à deux ou à plusieurs ..." />
                                            </div>

                                            <div className='menu_carte mt-5'>
                                                <div className='row'>
                                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                                        <div className="menu_carte_item">
                                                            <div className='d-flex justify-content-between header_item'>
                                                                <h3 className='details'>Entrée</h3>
                                                                <Form.Check
                                                                    type="switch"
                                                                    id="custom5"
                                                                    checked={menu.statusEntrer}
                                                                    onChange={() => handleUpdateStatusEntrer(menu.id)}
                                                                    className='mt-2'

                                                                />
                                                            </div>
                                                            <div className='d-flex mt-2'>
                                                                <input type="text" value={updateEntrer} onChange={(e) => setUpdateEntrer(e.target.value)} className='form-control form-control-sm' placeholder='Entrée ...' />
                                                                <button type="button" className='btn btn-sm' onClick={() => handleAddUpdateEntrer(menu.id)}><i className='fa fa-plus'></i></button>
                                                            </div>


                                                            {entrerView(menu.id)}

                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                                        <div className="menu_carte_item">
                                                            <div className="d-flex justify-content-between header_item">
                                                                <h3 className='details'>Plats</h3>
                                                                <Form.Check
                                                                    type="switch"
                                                                    id="custom5"
                                                                    checked={menu.statusPlat}
                                                                    onChange={() => handleUpdateStatusPlat(menu.id)}
                                                                    className='mt-2'

                                                                />
                                                            </div>
                                                            <div className='d-flex mt-2'>
                                                                <input type="text" value={updatePlat} onChange={(e) => setUpdatePlat(e.target.value)} className='form-control form-control-sm' placeholder='Plats ...' />
                                                                <button type="button" className='btn btn-sm' onClick={() => handleAddUpdatePlat(menu.id)}><i className='fa fa-plus'></i></button>
                                                            </div>


                                                            {viewPlat(menu.id)}


                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                                        <div className="menu_carte_item">
                                                            <div className='d-flex justify-content-between header_item'>
                                                                <h3 className='details'>Dessert</h3>
                                                                <Form.Check
                                                                    type="switch"
                                                                    id="custom5"
                                                                    checked={menu.statusDessert}
                                                                    onChange={() => handleUpdateStatusDessert(menu.id)}
                                                                    className='mt-2'

                                                                />
                                                            </div>
                                                            <div className='d-flex mt-2'>
                                                                <input type="text" value={updateDessert} onChange={(e) => setUpdateDessert(e.target.value)} className='form-control form-control-sm' placeholder='Dessert ...' />
                                                                <button type="button" className='btn btn-sm' onClick={() => handleUpdateAddDessert(menu.id)}><i className='fa fa-plus'></i></button>
                                                            </div>


                                                            {viewDessert(menu.id)}


                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                                        <div className="menu_carte_item">

                                                            <div className='d-flex'>
                                                                <Form.Check
                                                                    type="switch"
                                                                    id="custom5"
                                                                    checked={menu.statusAutre}
                                                                    onChange={() => handleStatusAutre(menu.id)}
                                                                    className='mt-2'

                                                                />
                                                                <input type="text" value={menu.nomAutre} onChange={(e) => handleUpdateNomAutre(menu.id, e.target.value)} className='form-control form-control-sm' placeholder='Nom ...' />
                                                            </div>
                                                            <div className='d-flex mt-2'>
                                                                <input type="text" value={updateAutre} onChange={(e) => setUpdateAutre(e.target.value)} className='form-control form-control-sm' placeholder='Item ...' />
                                                                <button type="submit" className='btn btn-sm' onClick={() => handleUpdateAddAutre(menu.id)}><i className='fa fa-plus'></i></button>
                                                            </div>

                                                            {viewAutre(menu.id)}


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex mt-2'>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom6"
                                                    className='mt-2'
                                                    defaultChecked="true"
                                                />
                                                <h3 className='remarque'>Ce menu est seulement indicatif et les plats listés ci-dessus peuvent changer en fonction des arrivages.</h3>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })

                            : ''}






                </div>


                {/* 
       MODAL COMPONENT    */}



                <Modal show={showModal} fullscreen={fullscreen} onHide={handleClose}>
                    <Modal.Body>
                        <div className='modal_visualiser'>
                            <div className='modal_visualiser_header'>
                                <h5>L'aperçue de votre donner dans la page restaurants</h5>
                                <span className='close' onClick={handleClose}><i className='fa fa-close'></i></span>
                            </div>
                            <div className='restoPageMenu'>
                                <div className='restoPage_content'>
                                    <div className='resto_option'>
                                        <div className='row'>
                                            <div className='col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8'>
                                                <div className='resto_apropos'>
                                                    <div className='resto_apropos_content'>
                                                        <h1 className='text-center'>{restaurant.nomRestaurant}</h1>
                                                        <div className='cuisine_prix'>
                                                            <div className="row">

                                                                {cuisine.length !== 0 ?
                                                                    cuisine.map((item, index) => {
                                                                        return (
                                                                            <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-3' key={index}>
                                                                                <span ><i className='fa fa-cutlery'></i>{item.libelle}</span>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    : ''}

                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                    <span><i className='fa fa-map-marker'></i>{restaurant.adresse}</span>
                                                                </div>
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                    <span><i className='fa fa-bookmark'></i>Prix Moyenne de  {prixMoyen.length !== 0 ? prixMoyen[0]?.prix : "000"} Ar</span>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className='favoris_gif'>
                                                            <i className='fa fa-heart'></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
                                                <div className='resto_favoris'>
                                                    <div className='resto_favoris_content'>
                                                        <div className="d-flex justify-content-center">
                                                            <div className='resto_note_avis'>
                                                                <div>
                                                                    <div className='resto_note'>Note/<span>{restaurant.notes && restaurant.notes.length === 0 ? 0 : restaurant.notes[0].note}</span></div>
                                                                    <div className='resto_avis'>Avis/<span>{restaurant.avis && restaurant.avis.length === 0 ? 0 : restaurant.avis.length}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-center">
                                                            {promotion.length === 0 ? <div className='resto_promotion mb-4'>
                                                                {viewPromotion()}
                                                            </div> :
                                                                <div className='resto_promotion'>
                                                                    {viewPromotion()}
                                                                    {restaurant.creneauPromos.length !== 0 ?
                                                                        viewCreneau(restaurant.creneauPromos[0])
                                                                        : ''}
                                                                </div>}
                                                        </div>
                                                    </div>
                                                    <div className='resto_footer_reserver'>
                                                        <div className='d-flex justify-content-center'>
                                                            <button className="btn">Réserver</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='resto_photos'>
                                        <PhotoProvider>
                                            {selectImage.length !== 0 ?
                                                <Slider {...settings}>
                                                    {selectImage.map((item, index) => {
                                                        return (<div className='image' key={index}>
                                                            <PhotoView src={BASE_URL + item.urlPhoto}>
                                                                <img src={BASE_URL + item.urlPhoto} alt="logo restaurant" />
                                                            </PhotoView>
                                                        </div>)
                                                    })}
                                                </Slider>
                                                : <p>Photos non disponible ...</p>}
                                        </PhotoProvider>

                                    </div>
                                    <div className='resto_description'>
                                        <h2> <i className='fa fa-tag'></i>Description du restaurant</h2>
                                        <div className='resto_description_content'>
                                            <div className='chef'>
                                                <img src={Chef} alt="chef avatar" />
                                            </div>
                                            <p>{description === null ? 'Description non disponible ...' : description.split('\n').map((line, index) => (
          <div key={index}>{line}</div>
        ))}</p>
                                        </div>

                                    </div>



                                    <div className='row'>


                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8'>
                                            <Tabs
                                                defaultActiveKey="carte"
                                                id="fill-tab-example"
                                                className="mb-3"
                                                justify
                                            >
                                                <Tab eventKey="carte" title="Cartes">
                                                    {entrerResto.length === 0 && platResto.length === 0 && dessertResto.length === 0 && boisson.length === 0 ?
                                                        <h4> <i className='fa fa-cutlery pas'></i>Pas de contenue dans la carte</h4>
                                                        :
                                                        <h4> <i className='fa fa-cutlery'></i>A la carte</h4>
                                                    }

                                                    <div className='resto_carte'>
                                                        <div className='row'>
                                                            {entrerResto.length !== 0 ?
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                    <div className='resto_carte_bloc'>
                                                                        <h5 className='text-center'>Entrées</h5>
                                                                        {entrerResto.map((item, index) => {
                                                                            if (index === entrerResto.length - 1) {
                                                                                return (<div className='resto_entrer' key={index}>
                                                                                    <div className='img'>
                                                                                        <img src={EntrerIcon} alt="avatar carte" />
                                                                                    </div>
                                                                                    <div className='resto_carte_content'>
                                                                                        <h6>{item.libelle}</h6>
                                                                                        <span>{item.prix} Ar</span>
                                                                                    </div>
                                                                                </div>)
                                                                            } else {
                                                                                return (<>
                                                                                    <div className='resto_entrer' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={EntrerIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <hr />
                                                                                </>)
                                                                            }

                                                                        })}


                                                                    </div>
                                                                </div>
                                                                : ''}

                                                            {platResto.length !== 0 ?
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                    <div className='resto_carte_bloc'>
                                                                        <h5 className='text-center'>Plats</h5>
                                                                        {platResto.map((item, index) => {
                                                                            if (index === platResto.length - 1) {
                                                                                return (<div className='resto_plat' key={index}>
                                                                                    <div className='img'>
                                                                                        <img src={PlatIcon} alt="avatar carte" />
                                                                                    </div>
                                                                                    <div className='resto_carte_content'>
                                                                                        <h6>{item.libelle}</h6>
                                                                                        <span>{item.prix} Ar</span>
                                                                                    </div>
                                                                                </div>)
                                                                            } else {
                                                                                return (<>
                                                                                    <div className='resto_plat' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={PlatIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <hr />
                                                                                </>
                                                                                )
                                                                            }

                                                                        })}

                                                                    </div>
                                                                </div>
                                                                : ''}


                                                            {dessertResto.length !== 0 ?
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                    <div className='resto_carte_bloc'>
                                                                        <h5 className='text-center'>Desserts</h5>

                                                                        {dessertResto.map((item, index) => {
                                                                            if (index === dessertResto.length - 1) {
                                                                                return (
                                                                                    <div className='resto_dessert' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={DessertIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <>
                                                                                        <div className='resto_dessert' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={DessertIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <hr />
                                                                                    </>
                                                                                )
                                                                            }
                                                                        })}


                                                                    </div>

                                                                </div>
                                                                : ''}


                                                            {boisson.length !== 0 ?

                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                    <div className='resto_carte_bloc'>
                                                                        <h5 className='text-center boisson'>Boissons</h5>
                                                                        {boisson.map((item, index) => {
                                                                            if (index === boisson.length - 1) {
                                                                                return (
                                                                                    <div className='resto_boisson' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={BoissonIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <>
                                                                                        <div className='resto_boisson' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={BoissonIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <hr />
                                                                                    </>
                                                                                )
                                                                            }
                                                                        })}



                                                                    </div>

                                                                </div>
                                                                : ''}

                                                        </div>
                                                    </div>
                                                </Tab>



                                                <Tab eventKey="menu" title="Menus">
                                                    {data.length === 0 ? <h4> <i className='fa fa-cutlery pas'></i>Pas de contenu dans le Menus</h4> : <h4> <i className='fa fa-cutlery'></i>Menus</h4>}

                                                    <div className="row p-2">

                                                        {data.map((item, index) => {
                                                            return (
                                                                <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4' key={index}>
                                                                    <div className='resto_menus'>
                                                                        <div className='resto_menu_header'>
                                                                            <div className='img'>
                                                                                <img src={MenusAvatar} alt="avatar menus" />
                                                                            </div>
                                                                            <div className='resto_menu_titre'>
                                                                                <h5>{item.libelleMenu} à <span>{item.prixMenu} Ar</span></h5>
                                                                            </div>
                                                                        </div>
                                                                        <div className='resto_menu_content'>
                                                                            <p>{item.introduire.slice(0, 80)}...</p>
                                                                            <div className='d-flex justify-content-center'>
                                                                                <button className='btn' onClick={() => handleShowDetailMenu(item)}>Voir le détail de ce menu</button>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            );
                                                        })}

                                                    </div>


                                                </Tab>



                                                <Tab eventKey="avecOffre" title="Avec Offres">
                                                    <div className='resto_promo_map'>
                                                        <div className='row'>
                                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                <div className='resto_promo_titre'>
                                                                    <h4> <i className='fa fa-bullhorn'></i>Avec Offre</h4>
                                                                </div>
                                                                <div className='resto_promo_content'>

                                                                    {promotion.length !== 0 ?
                                                                        promotion.map((elPromo, iPromo) => {
                                                                            if (elPromo.libelle === "Promotion de -50%") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : -50% sur la carte</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                </div>);
                                                                            } else if (elPromo.libelle === "Promotion de -40%") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : -40% sur la carte</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                </div>);
                                                                            } else if (elPromo.libelle === "Promotion de -30%") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : -30% sur la carte</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                </div>);
                                                                            } else if (elPromo.libelle === "Promotion de -20%") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : -20% sur la carte</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                </div>);
                                                                            } else if (elPromo.libelle === "Promotion de -10%") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : -10% sur la carte</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                </div>);
                                                                            } else if (elPromo.libelle === "Promotion : Menu spécial") {
                                                                                return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                    <div className='item_liste'>
                                                                                        <h5>Promo : {promoSpecial.length !== 0 ? promoSpecial[0].libelle : "Promotion special"} à {promoSpecial.length !== 0 ? promoSpecial[0].prix : "000"} Ar</h5>
                                                                                        <span>Précision / conditions / validité</span>
                                                                                    </div>
                                                                                    <div className='item_action_creneau creneau_special'>
                                                                                        {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                                                                    </div>
                                                                                    <div className='item_action_content'>
                                                                                        <div className='item_action_creneau_responsive'>
                                                                                            {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)
                                                                            } else {
                                                                                return ("");
                                                                            }
                                                                        })
                                                                        : <p>Pas de promotion ...</p>}



                                                                </div>
                                                                <div className='resto_promo_titre mt-3'>
                                                                    <h4> <i className='fa fa-bullhorn'></i>Sans Offre</h4>
                                                                </div>
                                                                <div className='resto_promo_content'>
                                                                    <div className='resto_promo_content_item'>
                                                                        <div className='item_liste'>
                                                                            <h5>Réservations simple</h5>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </Tab>




                                                <Tab eventKey="avis" title={"Nombre d'avis" + restaurant?.avis.length}>
                                                    <div className='resto_avis'>
                                                        <div className='resto_avis_header'>
                                                            <h4><i className='fa fa-tag'></i> Nombre d'avis {restaurant?.avis.length}</h4>
                                                        </div>
                                                        <div className='resto_avis_content'>

                                                            {restaurant?.avis.map((el, index) => {
                                                                return (
                                                                    viewAvisListe(el, index)
                                                                )
                                                            })}



                                                            {/* <div className='d-flex justify-content-center'>
                                                                    <div className='pagination_avis'>
                                                                        <Pagination count={10} />
                                                                    </div>
                                                                </div> */}
                                                        </div>
                                                    </div>
                                                </Tab>
                                            </Tabs>

                                        </div>


                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4'>
                                            <div className='payement_plus'>
                                                <div className='payement_plusContent'>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div className='plus_restaurant'>
                                                            <div className='d-flex justify-content-center'>
                                                                <div className='titre_plus'>
                                                                    <span><i className='fa fa-bolt'></i> Les + du restaurant</span>
                                                                </div>
                                                            </div>
                                                            <div className='plus_content'>
                                                                <div className='row'>
                                                                    {service.length !== 0 ?
                                                                        service.map((item, index) => {
                                                                            return (
                                                                                <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                    <div className='item_plus'>
                                                                                        <div className='image_plus'>
                                                                                            <img src={Plus} alt="avatar plus restaurant" />
                                                                                        </div>
                                                                                        <div className='value_plus'>
                                                                                            <span>{item.libelle}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                        : ''}
                                                                    {regime.length !== 0 ?
                                                                        regime.map((item, index) => {
                                                                            return (
                                                                                <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                    <div className='item_plus'>
                                                                                        <div className='image_plus'>
                                                                                            <img src={Plus} alt="avatar plus restaurant" />
                                                                                        </div>
                                                                                        <div className='value_plus'>
                                                                                            <span>{item.libelle}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                        : ''}


                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div className='payement_restaurant'>
                                                            <div className='payement_restaurantContent'>
                                                                <div className='titre_payement'>
                                                                    <span><i className='fa fa-money'></i> Mode de payement acceptés</span>
                                                                </div>
                                                            </div>
                                                            <div className='payement_content'>
                                                                <div className='row'>
                                                                    {payement.length !== 0 ?
                                                                        payement.map((item, index) => {
                                                                            return (<div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                <div className='item_payement'>
                                                                                    <div className='image_payement'>
                                                                                        <img src={Money} alt="avatar plus restaurant" />
                                                                                    </div>
                                                                                    <div className='value_payement'>
                                                                                        <span>{item.libelle}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>)
                                                                        })

                                                                        : ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                        <div className='resto_map'>
                                                            <div className='resto_map_titre'>
                                                                <h4> <i className='fa fa-map-marker'></i>Localisation – Plan / adresse</h4>
                                                            </div>

                                                            <div className="resto_map_content">
                                                                <h5>Adresse</h5>
                                                                <p>{restaurant.adresse} : {restaurant.precision}</p>
                                                                <PhotoProvider>
                                                                    {planUrl !== null ?
                                                                        <div className='resto_map_image'>
                                                                            <PhotoView src={BASE_URL + planUrl}>
                                                                                <img src={BASE_URL + planUrl} alt="avatar map" />
                                                                            </PhotoView>
                                                                        </div>
                                                                        : ''}
                                                                </PhotoProvider>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>






                                    {restaurant?.photoRestos.length !== 0 ?
                                        <div className="resto_photo_telecharger">
                                            <div className='resto_photo_telecharger_titre'>
                                                <h4> <i className='fa fa-photo'></i>Photo des clients</h4>
                                            </div>
                                            <div className='row'>
                                                <PhotoProvider>
                                                    {restaurant?.photoRestos.map((element, index) => {
                                                        return (
                                                            <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' key={index}>
                                                                <div className='resto_photo_img'>
                                                                    <PhotoView src={BASE_URL + element.photoUrl}>
                                                                        <img src={BASE_URL + element.photoUrl} alt="telecharger client" />
                                                                    </PhotoView>
                                                                </div>
                                                            </div>)
                                                    })}
                                                </PhotoProvider>

                                            </div>
                                        </div>
                                        : ""}






                                </div>
                                <Modal
                                    show={show}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered

                                    onHide={handleCloseDetailMenu}
                                >
                                    <Modal.Body className="shadow">
                                        <div className='modal_detail_menu'>
                                            <div className='header_detail_menu'>
                                                <h5>{elementMenu.libelleMenu} à <span>{elementMenu.prixMenu} Ar</span></h5>
                                                <span className='close' onClick={handleCloseDetailMenu}><i className='fa fa-close'></i></span>
                                            </div>
                                            <div className='content_detail_menu'>
                                                <div className='content_detail_description'>
                                                    <h6>Ce menu comprend:</h6>
                                                    <div className='content_detail_liste mt-2'>
                                                        {elementMenu.platMenu !== "" && elementAvecContenu?.length !== 0 ?
                                                            <><span className='detail_liste'>{elementMenu.platMenu}</span>
                                                                <span className='detail_plus'>+</span></> :
                                                            elementMenu.platMenu !== "" && elementAvecContenu?.length === 0 ?
                                                                <span className='detail_liste'>{elementMenu.platMenu}</span>
                                                                : ""
                                                        }

                                                        {elementMenu.autrePlatMenu !== "" && elementAvecContenu?.length !== 0 ?
                                                            <><span className='detail_liste'>{elementMenu.autrePlatMenu}</span> <span className='detail_plus'>+</span></> :
                                                            elementMenu.autrePlatMenu !== "" && elementAvecContenu?.length === 0 ?
                                                                <span className='detail_liste'>{elementMenu.autrePlatMenu}</span> : ''}


                                                        {elementAvecContenu?.length !== 0 ?
                                                            elementAvecContenu?.map((elAvec, iAvec) => {
                                                                if (iAvec === elementAvecContenu?.length - 1) {
                                                                    return (<span className='detail_liste' key={iAvec}>{elAvec.name}</span>);
                                                                } else {

                                                                    return (<div key={iAvec} ><span className='detail_liste'>{elAvec.name}</span><span className='detail_plus'>+</span></div>);
                                                                }

                                                            })
                                                            : ''}
                                                    </div>
                                                    <h6>Ce menu disponible:</h6>
                                                    <div className='content_detail_liste mt-2'>

                                                        {elementMoment?.length !== 0 ?
                                                            elementMoment?.map((elMoment, iMoment) => {
                                                                return (
                                                                    <span className='detail_liste_disponible' key={iMoment}>{elMoment.name}</span>
                                                                );
                                                            }) : ""}



                                                    </div>
                                                    <div className='content_detail_liste mt-3'>
                                                        <span className='me-2' >Le</span>
                                                        {elementDisponible?.length !== 0 ?
                                                            elementDisponible?.map((elJour, iJour) => {
                                                                return (<span className='detail_liste_disponible' key={iJour}>{elJour.name}</span>);
                                                            })
                                                            : ''}
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    {elementEntrer?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Entrée</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {elementEntrer?.map((elEntrer, iEntrer) => {
                                                                        if (iEntrer === elementEntrer?.length - 1) {
                                                                            return (<span key={iEntrer}>{elEntrer.name}</span>);
                                                                        } else {

                                                                            return (<><span key={iEntrer}>{elEntrer.name}</span>
                                                                                <hr /></>);
                                                                        }

                                                                    })}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}


                                                    {elementPlat?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Plats</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {elementPlat?.map((elPlat, iPlat) => {
                                                                        if (iPlat === elementPlat?.length - 1) {
                                                                            return (<span key={iPlat}>{elPlat.name}</span>);
                                                                        } else {

                                                                            return (<><span key={iPlat}>{elPlat.name}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}


                                                    {elementDessert?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Dessert</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {elementDessert?.map((elDessert, iDessert) => {
                                                                        if (iDessert === elementDessert?.length - 1) {
                                                                            return (<span key={iDessert}>{elDessert.name}</span>);
                                                                        } else {
                                                                            return (<><span key={iDessert}>{elDessert.name}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}
                                                    {elementAutre?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>{elementMenu.nomAutre}</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {elementAutre?.map((elAutre, iAutre) => {
                                                                        if (iAutre === elementAutre?.length - 1) {
                                                                            return (<span key={iAutre}>{elAutre.name}</span>);
                                                                        } else {
                                                                            return (<><span key={iAutre}>{elAutre.name}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}

                                                </div>
                                                <p className='mt-3'>
                                                    {elementMenu.introduire}
                                                </p>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>




                                <Modal
                                    show={showSpecial}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered

                                    onHide={handleCloseDetailSpecial}
                                >
                                    <Modal.Body className="shadow">
                                        <div className='modal_detail_menu'>
                                            <div className='header_detail_menu'>
                                                <h5>{promoSpecial[0]?.libelle} à <span>{promoSpecial[0]?.prix} Ar</span></h5>
                                                <span className='close' onClick={handleCloseDetailSpecial}><i className='fa fa-close'></i></span>
                                            </div>
                                            <div className='content_detail_menu'>
                                                <div className='content_detail_description'>
                                                    <h6>Ce menu comprend:</h6>
                                                    <div className='content_detail_liste mt-2'>
                                                        <span className='detail_liste'>{promoSpecial[0]?.platMenu !== "" ? promoSpecial[0]?.platMenu : promoSpecial[0]?.autrePlatMenu}</span>


                                                        {promoSpecial[0]?.avecContenuSpecials?.length !== 0 ?
                                                            <>
                                                                <span className='detail_plus'>+</span>
                                                                {promoSpecial[0]?.avecContenuSpecials?.map((elAvec, iAvec) => {
                                                                    if (iAvec === promoSpecial[0]?.avecContenuSpecials?.length - 1) {
                                                                        return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                                                    } else {
                                                                        return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                                                    }

                                                                })}
                                                            </>
                                                            : ''}
                                                    </div>

                                                </div>
                                                <div className='row'>
                                                    {promoSpecial[0]?.entrerSpecials?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Entrée</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {promoSpecial[0]?.entrerSpecials?.map((elEntrer, iEntrer) => {
                                                                        if (iEntrer === promoSpecial[0]?.entrerSpecials?.length - 1) {
                                                                            return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                                                        } else {

                                                                            return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                                                                <hr /></>);
                                                                        }

                                                                    })}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}


                                                    {promoSpecial[0]?.platSpecials?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Plats</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {promoSpecial[0]?.platSpecials?.map((elPlat, iPlat) => {
                                                                        if (iPlat === promoSpecial[0]?.platSpecials?.length - 1) {
                                                                            return (<span key={iPlat}>{elPlat.libelle}</span>);
                                                                        } else {

                                                                            return (<><span key={iPlat}>{elPlat.libelle}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}


                                                    {promoSpecial[0]?.dessertSpecials?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>Dessert</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {promoSpecial[0]?.dessertSpecials?.map((elDessert, iDessert) => {
                                                                        if (iDessert === promoSpecial[0]?.dessertSpecials?.length - 1) {
                                                                            return (<span key={iDessert}>{elDessert.libelle}</span>);
                                                                        } else {
                                                                            return (<><span key={iDessert}>{elDessert.libelle}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}
                                                    {promoSpecial[0]?.autreSpecials?.length !== 0 ?
                                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className='content_detail_item'>
                                                                <div className='content_detail_itemTitre'>
                                                                    <h6 className='text-center'>{promoSpecial[0]?.nomAutre}</h6>

                                                                </div>
                                                                <div className='content_detail_itemListe'>
                                                                    {promoSpecial[0]?.autreSpecials?.map((elAutre, iAutre) => {
                                                                        if (iAutre === promoSpecial[0]?.autreSpecials?.length - 1) {
                                                                            return (<span key={iAutre}>{elAutre.libelle}</span>);
                                                                        } else {
                                                                            return (<><span key={iAutre}>{elAutre.libelle}</span>
                                                                                <hr /></>)
                                                                        }
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}

                                                </div>
                                                <p className='mt-3'>
                                                    {promoSpecial[0]?.introduire}
                                                </p>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>

                            </div>
                        </div>
                    </Modal.Body>
                </Modal>


            </div>

        </div>
    )
}

export default Menus